import React from 'react';
import { DataGrid, DataGridProps } from '@material-ui/data-grid';
import { CustomNoRowsOverlay } from '@components/datagrid/custom.no.rows.overlay';
import MainPagination from '@components/main.pagination';
import { ErrorDisplay } from '@components/error/error.display';

interface MainDataGridProps extends DataGridProps {
  pageCount?: number;
  defaultPagination?: boolean;
}

export const MainDataGrid = ({ components, componentsProps, error, pageCount, defaultPagination, ...rest }: MainDataGridProps) => {
  const { pagination, ...otherComponentsProps } = componentsProps || {};

  const errorObj = error ? { error } : undefined;

  return (
    <DataGrid
      components={{
        NoRowsOverlay: CustomNoRowsOverlay,
        Pagination: defaultPagination ? undefined : MainPagination,
        ErrorOverlay: ErrorDisplay,
        ...components,
      }}
      componentsProps={{
        pagination: defaultPagination ? pagination : { forGrid: true, count: pageCount, ...pagination },
        errorOverlay: { forGrid: true },
        ...otherComponentsProps,
      }}
      error={errorObj}
      pageSize={20}
      {...rest}
    />
  );
};
